<template>
  <!-- Fila única para todo el contenido -->
  <v-row class="fill-height" align-content="center" justify="center">
    <!-- Columna para el texto -->
    <v-col
      cols="12"
      class="subtitle-1 text-center font-weight-bold text--disabled"
    >
      <slot></slot>
    </v-col>
    <!-- Columna para el spinner -->
    <v-col :cols="progressLinearWidth">
      <v-progress-linear color="primary" indeterminate rounded height="6" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "LinearLoading",
  props: {
    progressLinearWidth: {
      type: Number,
      required: false,
      default: 6
    }
  }
};
</script>
